import { PROTECTED_GRAPHQL_ENDPOINT, PUBLIC_API_KEY, PUBLIC_GRAPHQL_ENDPOINT } from 'settings';

const AppSync = {
  protectedGraphqlEndpoint: PROTECTED_GRAPHQL_ENDPOINT,
  publicApiKey: PUBLIC_API_KEY,
  publicGraphqlEndpoint: PUBLIC_GRAPHQL_ENDPOINT,
};

export default AppSync;
